export default __webpack_public_path__ + "static/media/postexpress.b6d2d338.ico";